import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import './datePicker.scss';

class DatePickerComponent extends React.Component {
    render() {
        const { formProps, className, selected } = this.props;

        return <div className="custom-date-picker-wrapper">
            <DatePicker
                {...formProps}
                ref="datePicker"
                className={className}
                calendarClassName="custom-date-picker"
                selected={selected ? moment(selected) : moment()}
                readOnly
                onClickOutside={() => {
                    this.refs.datePicker.cancelFocusInput();
                    this.refs.datePicker.setOpen(false);
                }}
            >
                <div className="date-picker-footer">
                    {moment().format('dddd, MMMM D, YYYY')}
                </div>
            </DatePicker>
        </div>;
    }
}

DatePickerComponent.defaultProps = {
    className: '',
    formProps: {},
    selected: moment(),
};

DatePickerComponent.propTypes = {
    className: PropTypes.string.isRequired,
    formProps: PropTypes.object.isRequired,
    selected: PropTypes.any,
};

export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/components/core/DatePickerComponent/DatePickerComponent.js